<template>
  <header class="app-header" :class="[
      {'app-header--active': showMobileMenu},
      `app-header--${headerTheme}`
    ]">
    <!-- Logo部分（PC和Mobile共用） -->
    <div class="app-header__logo" @click="goToHome">
      <img :src="domainConfig?.['siteIcon']" class="app-header__logo-icon" alt="">
      <div class="app-header__logo-text">
        {{domainConfig?.['siteName']}}
      </div>
    </div>

    <!-- PC导航菜单 (只在桌面设备显示) -->
    <nav class="app-header__nav" v-if="deviceType === 'desktop' || deviceType === 'pc'">
      <!-- Home -->
      <div class="app-header__nav-item"
        :class="{'app-header__nav-item--active': isRouteActive('/')}" @click="goToHome">
        <span>Home</span>
      </div>

      <!-- Name Generator -->
      <div class="app-header__nav-item"
        :class="{'app-header__nav-item--active': isRouteActive('/names')}"
        @click="navigateToPage('/names')">

        <span>Name Generator</span>
      </div>

      <!-- Names by Gender -->
      <div class="app-header__nav-item app-header__nav-item--has-dropdown"
        :class="{'app-header__nav-item--active': isRouteActive('/categories/gender')}"
        @click="toggleDropdown('gender')" ref="genderNavItem">

        <span>Names by Gender</span>
        <!-- Gender下拉菜单 -->
        <div class="app-header__dropdown app-header__dropdown--gender"
          v-if="activeDropdown === 'gender'" ref="genderDropdown">
          <div class="app-header__dropdown-menu app-header__dropdown-menu--gender">
            <div class="app-header__dropdown-item" v-for="item in genderItems" :key="item.value"
              @click="navigateToCategory('gender', item.value)">
              {{ item.label }}
            </div>
          </div>
        </div>
      </div>

      <!-- Names by Style -->
      <div class="app-header__nav-item app-header__nav-item--has-dropdown"
        :class="{'app-header__nav-item--active': isRouteActive('/categories/style')}"
        @click="toggleDropdown('style')" ref="styleNavItem">

        <span>Names by Style</span>
        <!-- Style下拉菜单 -->
        <div class="app-header__dropdown app-header__dropdown--style"
          v-if="activeDropdown === 'style'" ref="styleDropdown">
          <div class="app-header__dropdown-menu app-header__dropdown-menu--grid">
            <div class="app-header__dropdown-item" v-for="item in styleItems" :key="item.value"
              @click="navigateToCategory('style', item.value)">
              {{ item.label }}
            </div>
          </div>
        </div>
      </div>

      <!-- Names by Meaning -->
      <div class="app-header__nav-item app-header__nav-item--has-dropdown"
        :class="{'app-header__nav-item--active': isRouteActive('/categories/meaning')}"
        @click="toggleDropdown('meaning')" ref="meaningNavItem">

        <span>Names by Meaning</span>
        <!-- Meaning下拉菜单 -->
        <div class="app-header__dropdown app-header__dropdown--meaning"
          v-if="activeDropdown === 'meaning'" ref="meaningDropdown">
          <div class="app-header__dropdown-menu app-header__dropdown-menu--grid">
            <div class="app-header__dropdown-item" v-for="item in meaningItems" :key="item.value"
              @click="navigateToCategory('meaning', item.value)">
              {{ item.label }}
            </div>
          </div>
        </div>
      </div>
    </nav>

    <!-- Mobile菜单按钮 (只在移动设备显示) -->
    <div class="app-header__mobile-trigger" v-if="deviceType === 'mobile'"
      @click="toggleMobileMenu">
      <img :class="{'close': showMobileMenu}"
        :src="showMobileMenu ? require('@/assets/default/menu-icon-close.svg') : require('@/assets/default/menu-icon.svg')"
        alt="">
    </div>

    <!-- Mobile菜单 (显示/隐藏取决于showMobileMenu) -->
    <div class="app-header__mobile-menu-row" v-if="showMobileMenu && deviceType === 'mobile'">
      <div class="app-header__mobile-menu">
        <!-- 顶部导航按钮 -->
        <div class="app-header__mobile-menu-nav">
          <div class="app-header__mobile-menu-nav-item app-header__mobile-menu-nav-item--active"
            :class="{'app-header__mobile-menu-nav-item--active': isRouteActive('/')}"
            @click="goToHome">
            <span>Home</span>
          </div>
          <div class="app-header__mobile-menu-nav-item app-header__mobile-menu-nav-item--active"
            :class="{'app-header__mobile-menu-nav-item--active': isRouteActive('/names')}"
            @click="navigateToPage('/names')">
            <span>Name Generator</span>
          </div>
        </div>

        <div class="app-header__mobile-menu-divider"></div>

        <!-- Names by Gender 部分 -->
        <div class="app-header__mobile-menu-section">
          <div class="app-header__mobile-menu-title">
            <img src="@/assets/icons/gender.svg" alt="">
            <span>Names by Gender</span>
          </div>
          <div class="app-header__mobile-menu-items app-header__mobile-menu-items--gender">
            <div class="app-header__mobile-menu-item" v-for="item in genderItems" :key="item.value"
              @click="navigateToCategory('gender', item.value)">
              <span>{{ item.label }}</span>
            </div>
          </div>
        </div>

        <div class="app-header__mobile-menu-divider"></div>

        <!-- Names by Style 部分 -->
        <div class="app-header__mobile-menu-section">
          <div class="app-header__mobile-menu-title">
            <img src="@/assets/icons/style.svg" alt="">
            <span>Names by Style</span>
          </div>
          <div class="app-header__mobile-menu-items">
            <div class="app-header__mobile-menu-grid">
              <div class="app-header__mobile-menu-item" v-for="item in styleItems" :key="item.value"
                @click="navigateToCategory('style', item.value)">
                <span>{{ item.label }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="app-header__mobile-menu-divider"></div>

        <!-- Names by Meaning 部分 -->
        <div class="app-header__mobile-menu-section">
          <div class="app-header__mobile-menu-title">
            <img src="@/assets/icons/meaning.svg" alt="">
            <span>Names by Meaning</span>
          </div>
          <div class="app-header__mobile-menu-items">
            <div class="app-header__mobile-menu-grid">
              <div class="app-header__mobile-menu-item" v-for="item in meaningItems"
                :key="item.value" @click="navigateToCategory('meaning', item.value)">
                <span>{{ item.label }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="app-header__mobile-menu-divider"></div>

        <!-- 底部链接 -->
        <div class="app-header__mobile-menu-links">
          <div class="app-header__mobile-menu-link" @click="navigateToPage('/categories')">
            <div>
              <span>Categories</span>
            </div>
            <img src="@/assets/default/arrow-right-small_w.svg"
              class="app-header__mobile-menu-link-arrow" alt="">
          </div>
          <div class="app-header__mobile-menu-link" @click="navigateToPage('/about-us')">
            <div>
              <span>About us</span>
            </div>
            <img src="@/assets/default/arrow-right-small_w.svg"
              class="app-header__mobile-menu-link-arrow" alt="">
          </div>
          <div class="app-header__mobile-menu-link" @click="navigateToPage('/terms-of-service')">
            <div>
              <span>Terms of Services</span>
            </div>
            <img src="@/assets/default/arrow-right-small_w.svg"
              class="app-header__mobile-menu-link-arrow" alt="">
          </div>
          <div class="app-header__mobile-menu-link" @click="navigateToPage('/privacy-policy')">
            <div>
              <span>Privacy Policy</span>
            </div>
            <img src="@/assets/default/arrow-right-small_w.svg"
              class="app-header__mobile-menu-link-arrow" alt="">
          </div>
          <div class="app-header__mobile-menu-link" @click="navigateToPage('/disclaimer')">
            <div>
              <span>Disclaimer</span>
            </div>
            <img src="@/assets/default/arrow-right-small_w.svg"
              class="app-header__mobile-menu-link-arrow" alt="">
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'AppHeader',
  components: {
  },
  props: {
    headerTheme: {
      type: String,
      default: 'light' // 可选值：'light'或'dark'
    },
  },
  computed: {
    ...mapGetters({
      deviceType: 'deviceType',
      domainConfig: 'domainConfig',
      gender: 'gender',
      style: 'style',
      meaning: 'meaning'
    }),
    genderItems () {
      if (!this.gender || this.gender.length === 0) return [];
      return this.gender.map(item => ({ label: item, value: item.toLowerCase() }));
    },
    styleItems () {
      if (!this.style || this.style.length === 0) return [];
      return this.style.map(item => ({ label: item, value: item.toLowerCase() }));
    },
    meaningItems () {
      if (!this.meaning || this.meaning.length === 0) return [];
      return this.meaning.map(item => ({ label: item, value: item.toLowerCase() }));
    },
  },
  data () {
    return {
      showMobileMenu: false,
      activeDropdown: null,
    };
  },
  methods: {
    toggleMobileMenu () {
      this.showMobileMenu = !this.showMobileMenu;

      // 如果打开菜单，禁止body滚动
      if (this.showMobileMenu) {
        document.body.style.overflow = 'hidden';
        document.body.style.height = '100%';
        document.body.style.position = 'fixed';
        document.body.style.width = '100%';
      } else {
        document.body.style.overflow = '';
        document.body.style.height = '';
        document.body.style.position = '';
        document.body.style.width = '';
      }
    },

    toggleDropdown (type) {
      if (this.activeDropdown === type) {
        this.activeDropdown = null;
      } else {
        this.activeDropdown = type;
      }
    },

    // 判断当前路由是否激活
    isRouteActive (link) {
      let currentPath = this.$route.path;
      const channel = this.$route.params.channel;

      if (channel && currentPath.startsWith(`/${channel}`)) {
        currentPath = currentPath.replace(`/${channel}`, '') || '/';
      }

      if (link === '/' && (currentPath === '/' || currentPath === '')) {
        return true;
      }

      if (link === '/' && currentPath !== '/') {
        return false;
      }

      return currentPath.startsWith(link);
    },

    goToHome () {
      if (this.$route.path !== '/') {
        if (this.$route.params.channel) {
          window.location.href = `/${this.$route.params.channel}`;
        } else {
          this.$router.push({ path: '/' });
        }
      }
    },

    navigateToPage (path) {
      if (this.$route.params.channel) {
        this.$router.push(`/${this.$route.params.channel}${path}`);
      } else {
        this.$router.push(path);
      }
    },

    navigateToCategory (cate, value) {
      const path = `/categories/${cate}/${value}`;
      this.navigateToPage(path);
      this.activeDropdown = null;
    },

    handleClickOutside (event) {
      if (!this.activeDropdown) return;

      const target = event.target;
      const isClickInside = (refName) => {
        const ref = this.$refs[refName];
        return ref && (ref === target || ref.contains(target));
      }

      if (!isClickInside(`${this.activeDropdown}NavItem`) && !isClickInside(`${this.activeDropdown}Dropdown`)) {
        this.activeDropdown = null;
      }
    },
  },
  beforeDestroy () {
    document.body.style.overflow = '';
    document.body.style.height = '';
    document.body.style.position = '';
    document.body.style.width = '';
    document.removeEventListener('click', this.handleClickOutside);
  },
  mounted () {
    this.$router.afterEach(() => {
      if (this.showMobileMenu) {
        this.showMobileMenu = false;
        document.body.style.overflow = '';
        document.body.style.height = '';
        document.body.style.position = '';
        document.body.style.width = '';
      }
      this.activeDropdown = null;
    });
    document.addEventListener('click', this.handleClickOutside);
  }
};
</script>

<style lang="scss">
@import '~@/css/variables.scss';

.app-header {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	position: relative;
	width: 100%;
	box-sizing: border-box;
	z-index: 100;
	height: rem(60);

	&--light {
		color: #ffffff;
	}

	&--dark {
		color: #ffffff;
	}

	&__logo {
		display: flex;
		flex-direction: row;
		gap: rem(16);
		align-items: center;
		justify-content: flex-start;
		flex-shrink: 0;
		position: relative;
		cursor: pointer;
		padding: rem(16) 0;
		font-family: 'Aboreto';

		&-icon {
			flex-shrink: 0;
			width: rem(36);
			height: rem(36);
			position: relative;
			overflow: visible;
		}

		&-text {
			color: #ffffff;
			text-align: left;
			font-size: rem(28);
			line-height: rem(28);
			font-weight: 400;
			text-transform: uppercase;
			position: relative;
		}
	}

	&__nav {
		display: flex;
		flex-direction: row;
		gap: rem(52);
		align-items: center;
		justify-content: flex-start;
		flex-shrink: 0;
		position: relative;
		height: 100%;

		&-icon {
			flex-shrink: 0;
			width: rem(14);
			height: rem(14);
			position: relative;
			overflow: visible;
			path {
				fill: #fff;
			}
		}

		&-item {
			display: flex;
			flex-direction: row;
			gap: rem(8);
			align-items: center;
			justify-content: flex-start;
			flex-shrink: 0;
			position: relative;
			height: 100%;
			cursor: pointer;
			transition: all 0.3s;
			padding: 0;
			box-sizing: content-box;

			span {
				color: #ffffff;
				text-align: left;
				font-size: rem(14);
				line-height: rem(14);
				font-weight: 400;
				position: relative;
			}

			&:hover {
				border-bottom: 2px solid #fff;

				span {
					color: #ffffff;
				}
				.app-header__nav-icon {
					path {
						fill: #fff;
					}
				}
			}
			&--active {
				border-bottom: 2px solid #fff;

				span {
					font-weight: 900;
					color: #fff;
				}

				.app-header__nav-icon {
					path {
						fill: #fff;
					}
				}
			}

			&--has-dropdown {
				position: relative;
			}
		}
	}

	&__dropdown {
		position: absolute;
		top: calc(100% + 4px);
		left: 50%;
		transform: translateX(-50%);
		z-index: 1000;

		&-menu {
			padding: rem(16);
			display: flex;
			flex-direction: column;
			gap: rem(8);
			border-radius: rem(16);
			border: rem(2) solid #000;
			background: #191919;

			&--gender {
				width: rem(200);
			}

			&--grid {
				display: grid;
				grid-template-columns: repeat(2, 1fr);
				gap: rem(8);
				width: rem(300);
			}
		}

		&-item {
			border-radius: rem(12);
			background: #000;
			padding: rem(12) rem(16);
			color: #ffffff;
			font-size: rem(14);
			line-height: rem(14);
			font-weight: 600;
			cursor: pointer;
			text-align: center;
			transition: background-color 0.3s ease, color 0.3s ease;

			&:hover {
				background: var(--Linear, linear-gradient(93deg, #08f 0%, #e54cba 50%, #c8ad17 100%));
				color: #fff;
			}
		}
	}

	&__mobile-trigger {
		flex-shrink: 0;
		width: rem(28);
		height: rem(28);
		position: relative;
		overflow: visible;
		cursor: pointer;
		display: flex;
		align-items: center;
		justify-content: center;

		img {
			width: rem(28);
			height: rem(28);
		}

		.close {
			width: rem(16);
			height: rem(16);
		}
	}

	&__mobile-menu-row {
		position: fixed;
		top: rem(60);
		height: calc(100vh - rem(60));
		left: 0;
		width: 100%;
		background: rgba(0, 0, 0, 0.5);
		z-index: 99;
	}

	&__mobile-menu {
		width: 100%;
		height: 100%;
		overflow: auto;
		background: #000;
		backdrop-filter: blur(5px);
		display: flex;
		flex-direction: column;
		padding: rem(32) rem(16);
		gap: rem(16);

		&-nav {
			display: flex;
			flex-direction: row;
			gap: rem(12);
			align-items: flex-start;
			justify-content: flex-start;
			width: 100%;

			&-item {
				background: rgba(255, 255, 255, 0.2);
				border-radius: rem(12);
				padding: rem(12) rem(16);
				display: flex;
				flex-direction: row;
				gap: rem(8);
				align-items: center;
				justify-content: flex-start;
				flex: 1;
				cursor: pointer;

				img {
					width: rem(14);
					height: rem(14);
				}

				span {
					color: #ffffff;
					font-size: rem(13);
					line-height: rem(14);
					font-weight: 400;
				}

				&--active {
					background: var(--Linear, linear-gradient(93deg, #08f 0%, #e54cba 50%, #c8ad17 100%));
					span {
						color: #fff;
						font-weight: 600;
					}
				}
			}
		}

		&-section {
			display: flex;
			flex-direction: column;
			gap: rem(12);
		}

		&-title {
			display: flex;
			flex-direction: row;
			gap: rem(8);
			align-items: center;
			padding: 0 rem(8);

			img {
				width: rem(14);
				height: rem(14);
			}

			span {
				color: #fff;
				font-size: rem(13);
				line-height: rem(14);
				font-weight: 400;
			}
		}

		&-items {
			display: flex;
			flex-direction: column;
			gap: rem(12);

			&--gender {
				flex-direction: row;
				.app-header__mobile-menu-item {
					flex: 1;
				}
			}
		}

		&-grid {
			display: flex;
			flex-direction: row;
			flex-wrap: wrap;
			gap: rem(12);
		}

		&-item {
			background: rgba(255, 255, 255, 0.2);
			border-radius: rem(12);
			padding: rem(12) rem(24);
			display: flex;
			align-items: center;
			justify-content: flex-start;
			flex: 1 0 calc(50% - rem(6));
			cursor: pointer;
			text-align: center;

			span {
				color: #fff;
				font-size: rem(14);
				line-height: rem(14);
				font-weight: 600;
			}
		}

		&-divider {
			border-style: dashed;
			border-color: rgba(255, 255, 255, 0.2);
			border-width: 1px;
			width: 100%;
			height: 1px;
		}

		&-links {
			display: flex;
			flex-direction: column;
			gap: rem(12);
		}

		&-link {
			border-radius: rem(12);
			border: 1px solid rgba(255, 255, 255, 0.2);
			padding: rem(12) rem(24);
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: space-between;
			cursor: pointer;

			div {
				display: flex;
				flex-direction: row;
				gap: rem(8);
				align-items: center;
			}

			img {
				width: rem(6);
			}

			span {
				color: #fff;
				font-size: rem(13);
				line-height: rem(14);
				font-weight: 400;
			}

			&-arrow {
				width: rem(6);
				height: rem(10);
			}
		}
	}

	&--active {
		background: #000;
	}
}

.detect_deviece_pc,
.detect_deviece_desktop {
	.app-header {
		padding: 0 rem(180);
	}
}

.detect_deviece_mobile {
	.app-header {
		padding: rem(10) rem(16);
		// background: #000;
		height: rem(60) !important;

		&--active {
			// background: #000 !important;
		}
		&__logo {
			max-width: 80%;
		}

		&__logo-text {
			font-size: rem(18);
			line-height: rem(18);
			font-weight: 900;
			text-transform: uppercase;
			position: relative;
			overflow: hidden;
			display: -webkit-box;
			text-overflow: ellipsis;
			-webkit-line-clamp: 2;
			-webkit-box-orient: vertical;
		}
	}
}
</style>

